import axios from "axios";
import {
  authHeader,
  authHeaderWithMultipartData,
  videoBotAuthHeader,
  videoBotAuthHeaderWithMultPartData,
} from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_ROOT_API;

const VIDEO_BOT_API_BASE_URL = process.env.VUE_APP_VIDEO_BOT_API_BASE_URL;

const PXB_API_URL = process.env.VUE_APP_PBX_API;

class UserService {
  // USER LOGIN BASED ON OTP RELATED APIs

  // Register New user
  registerUser(data) {
    return axios.post(API_URL + "user/new-user", data).then((response) => {
      return response.data;
    });
  }
  // Register New USer verification otp send
  verifyRegisterUserOTP(user_id, data) {
    return axios
      .patch(API_URL + "user/new-user/" + user_id, data)
      .then((response) => {
        return response.data;
      });
  }
  // SEND OTP API
  sendOTP(data) {
    return axios.post(API_URL + "user/login-wia-otp", data).then((response) => {
      return response.data;
    });
  }
  // SEND OTP API FOR PBX
  sendPbxOTP(data) {
    return axios.post(PXB_API_URL + "pbx-user/login", data).then((response) => {
      return response.data;
    });
  }

  // PROFILE RELATED API

  // Edit profile data
  updateProfile(data) {
    return axios
      .patch(API_URL + "user/detail", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  //   FCM TOKEN RELATED APIs

  // Guest user fcm token
  getUserFCMToken(filter = "") {
    return axios
      .get(API_URL + "user/fcm-device" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.data) {
          return response.data;
        }
      });
  }
  // Add Guest user fcm token
  addUserFCMToken(data) {
    return axios
      .post(API_URL + "user/fcm-device", data, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.data) {
          return response.data;
        }
      });
  }

  // STAFF LIST RELATED APIs

  //staff list
  getStaffList() {
    return axios
      .get(API_URL + "user/staff", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Get staff details
  getStaffDetails(staff_id) {
    return axios
      .get(API_URL + "user/staff/" + staff_id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create staff
  createStaff(data) {
    return axios
      .post(API_URL + "user/staff", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit staff
  editStaff(id, data) {
    return axios
      .patch(API_URL + "user/staff/" + id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete staff
  deleteStaff(id) {
    return axios
      .delete(API_URL + "user/staff/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // KIOSK POLICY RELATED APIs

  //get kiosk policy
  getKioskPolicyList() {
    return axios
      .get(API_URL + "user/kiosk", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //get kiosk policy
  getKioskPolicyDetails(id) {
    return axios
      .get(API_URL + "user/kiosk/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  getKioskPolicyDropdownList() {
    return axios
      .get(API_URL + "user/kiosk-name", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //update kiosk policy
  updateKioskPolicyList(data, kiosk_id) {
    return axios
      .patch(API_URL + "user/kiosk/" + kiosk_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //Refresh code
  refreshKioskCode(data, kiosk_id) {
    return axios
      .patch(API_URL + "user/kiosk/" + kiosk_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //UPLOAD IMAGES RELATED TO KIOSK MACHINE

  //Get all images of kiosk
  getKioskImages(kiosk_id) {
    return axios
      .get(API_URL + "user/kiosk-photo/" + kiosk_id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //Post a new images in kiosk
  postKioskImages(kiosk_id, data) {
    return axios
      .post(API_URL + "user/kiosk-photo/" + kiosk_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //Update kiosk images and order
  updateKioskImages(kiosk_id, image_id, data) {
    return axios
      .patch(API_URL + "user/kiosk-photo/" + kiosk_id + "/" + image_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete kiosk images
  deleteKioskImages(kiosk_id, id) {
    return axios
      .delete(API_URL + "user/kiosk-photo/" + kiosk_id + "/" + id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // KIOSK IMPORTANT MESSAGES

  // get all messages
  getKioskMessages(kiosk_id) {
    return axios
      .get(API_URL + "user/kiosk-important-message/" + kiosk_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //Post a new messages in kiosk
  postKioskMessage(kiosk_id, data) {
    return axios
      .post(API_URL + "user/kiosk-important-message/" + kiosk_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //Update kiosk message and order
  updateKioskMessage(kiosk_id, message_id, data) {
    return axios
      .patch(
        API_URL + "user/kiosk-important-message/" + kiosk_id + "/" + message_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  //delete kiosk message
  deleteKioskMessage(kiosk_id, message_id) {
    return axios
      .delete(
        API_URL + "user/kiosk-important-message/" + kiosk_id + "/" + message_id,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  //NEAR BY PLACE IMAGES RELATED APIs

  // Add  near by place list image
  addNearByPlaceImage(near_place_id, data) {
    return axios
      .post(
        API_URL + "hotel/nearby-place/" + near_place_id + "/place-image",
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Update near by place list image
  updateNearByPlaceImage(near_place_id, near_place_image_id, data) {
    return axios
      .patch(
        API_URL +
          "hotel/nearby-place/" +
          near_place_id +
          "/place-image/" +
          near_place_image_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Delete near by place list image
  deleteNearByPlaceImage(near_place_id, near_place_image_id) {
    return axios
      .delete(
        API_URL +
          "hotel/nearby-place/" +
          near_place_id +
          "/place-image/" +
          near_place_image_id,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  //LOCAL EVENT RELATED APIs

  // Get local event list
  getLocalEventList(filter) {
    return axios
      .get(API_URL + "hotel/local-event" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add local event list
  addLocalEvent(data) {
    return axios
      .post(API_URL + "hotel/local-event", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update local event
  updateLocalEvent(local_event_id, data) {
    return axios
      .patch(API_URL + "hotel/local-event/" + local_event_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete local event list
  deleteLocalEvent(local_event_id) {
    return axios
      .delete(API_URL + "hotel/local-event/" + local_event_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // TV CHANNEL RELATED APIs

  // Get tv channel category list
  getTvChannelCategory() {
    return axios
      .get(API_URL + "hotel/tv-channel/category", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add tv channel category
  addTvChannelCategory(data) {
    return axios
      .post(API_URL + "hotel/tv-channel/category", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update tv channel category
  updateTvChannelCategory(tv_channel_category_id, data) {
    return axios
      .patch(
        API_URL + "hotel/tv-channel/category/" + tv_channel_category_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Delete tv channel category
  deleteTvChannelCategory(tv_channel_category_id) {
    return axios
      .delete(API_URL + "hotel/tv-channel/category/" + tv_channel_category_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get TV channel list by category
  getTvChannelList(query) {
    return axios
      .get(API_URL + "hotel/tv-channel/info" + query, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add TV Channel
  addTVChannel(data) {
    return axios
      .post(API_URL + "hotel/tv-channel/info", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update TV Channel
  updateTVChannel(near_place_id, data) {
    return axios
      .patch(API_URL + "hotel/tv-channel/info/" + near_place_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete TV Channel
  deleteTVChannel(near_place_id) {
    return axios
      .delete(API_URL + "hotel/tv-channel/info/" + near_place_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //   ROLE AND ROLE PERMISSION RELATED APIs

  //role list
  getRoleList() {
    return axios
      .get(API_URL + "hotel/role", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create role
  createRole(data) {
    return axios
      .post(API_URL + "hotel/role", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Edit role
  editRole(id, data) {
    return axios
      .patch(API_URL + "hotel/role/" + id, data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Delete role
  deleteRole(id) {
    return axios
      .delete(API_URL + "hotel/role/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  //Role permission
  getRolePermissionList(role_id) {
    return axios
      .get(API_URL + "hotel/role-permission/" + role_id, {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }
  // update role permission
  updateRolePermissionList(role_permission_id, data) {
    return axios
      .patch(
        API_URL + "hotel/role-permission-edit/" + role_permission_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => response.data);
  }
  // Update all permission
  UpdateAllRolePermissions(role_id, data) {
    return axios
      .post(
        API_URL + "hotel/role-permission/" + role_id + "/bulk-update",
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => response.data);
  }

  // MAINTENCE REQURED RELATED APIs

  //Get all maintence request
  getAllMaintenceRequest() {
    return axios
      .get(API_URL + "hotel/maintenance-issue", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create new maintence request
  createMaintenceRequest(data) {
    return axios
      .post(API_URL + "hotel/maintenance-issue", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //  update maintence request by id
  updateMaintenceRequest(id, data) {
    return axios
      .patch(API_URL + "hotel/maintenance-issue/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete maintence request by id
  deleteMaintenceRequest(id) {
    return axios
      .delete(API_URL + "hotel/maintenance-issue/" + id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //Get details of maintence request item by id
  getMaintenceRequestDetails(id) {
    return axios
      .get(API_URL + "hotel/maintenance-issue/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //  Get Maintenance List Data
  getAllMaintenanceReq() {
    return axios
      .get(API_URL + "hotel/maintenance-detail", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //  Full Data of Maintenance  List
  getFullReqData(id) {
    return axios
      .get(API_URL + "hotel/maintenance-detail/" + id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //  update maintence request by id
  updateReqData(id, data) {
    return axios
      .patch(API_URL + "hotel/maintenance-detail/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //  Create New Maintence Request
  createNewMaintenanceReq(data) {
    return axios
      .post(API_URL + "hotel/maintenance-detail", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //  Create New Maintence Log
  createMaintenceLog(data) {
    return axios
      .post(API_URL + "hotel/maintenance-log", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // USER REVIEWS RELATED APIs

  // get all review list by user
  getUserReviewListByFilter(filter_string) {
    return axios
      .get(API_URL + "hotel/user-review" + filter_string, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // GET BRAND BASE THEME APIs

  // Get brand based themes
  getBrandWiseThemes(brand_id) {
    return axios
      .get(API_URL + "hotel/brand/" + brand_id + "/theme", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get all themes list
  getAllThemes() {
    return axios
      .get(API_URL + "hotel/brand/theme/all", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // BOOKING SOURCE LIST RELATED APIs

  //booking source list
  getBookingSourceList() {
    return axios
      .get(API_URL + "hotel-setting/booking-source", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create booking source
  createBookingSource(data) {
    return axios
      .post(API_URL + "hotel-setting/booking-source", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit booking source
  editBookingSource(data, booking_source_id) {
    return axios
      .patch(
        API_URL + "hotel-setting/booking-source/" + booking_source_id,
        data,
        {
          headers: authHeaderWithMultipartData(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  //booking rule delete
  deleteBookingSource(booking_source_id) {
    return axios.delete(
      API_URL + "hotel-setting/booking-source/" + booking_source_id,
      {
        headers: authHeader(),
      }
    );
  }
  //booking source details
  getBookingSourceDetails(booking_source_id) {
    return axios
      .get(API_URL + "hotel-setting/booking-source/" + booking_source_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //Booking source by name
  getBookingSourceByName() {
    return axios
      .get(API_URL + "hotel-setting/booking-source-name", {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  // BOOKING PAYMENT RULE RELATED APIs

  //booking payment rule
  getBookingSourcePaymentRule(booking_source_id) {
    return axios
      .get(API_URL + "hotel-setting/payment-rule/" + booking_source_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //booking payment rule update
  updateBookingPaymentRule(data, booking_source_id) {
    return axios
      .patch(
        API_URL + "hotel-setting/payment-rule/" + booking_source_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // PAYMENT GATEWAY RELATED APIs

  // connect payment gateway
  connectPaymentGetway(data) {
    return axios
      .post(API_URL + "hotel-setting/payment-gateway-connect", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // get stripe payment gateway details
  getStripePaymentGatewayDetails() {
    return axios
      .get(API_URL + "hotel-setting/payment-gateway", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // get payment gateway list
  getPaymentGatewayList() {
    return axios
      .get(API_URL + "hotel-setting/payment-gateway", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // PMS RELATED RELATED APIs

  // Get connected PMS
  getConnectedPMS() {
    return axios
      .get(API_URL + "hotel-setting/pms-connection", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add New PMS connection
  AddPMS(data) {
    return axios
      .post(API_URL + "hotel-setting/pms-connection/", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Sync PMS records
  syncPMSRecords() {
    return axios
      .get(API_URL + "hotel-setting/pms-synchroniz/booking", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Sync PMS Room records
  syncPMSRoomRecords() {
    return axios
      .get(API_URL + "hotel-setting/pms-synchroniz/room", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // pms-synchroniz-record
  getPMSSyncRecord(filter = "") {
    return axios
      .get(API_URL + "hotel-setting/pms-synchroniz-record" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //TERMS AND CONDITIONS RELATED APIs

  // get terms list
  getTermsList(filter) {
    return axios
      .get(API_URL + "hotel-setting/terms-and-condition" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // create terms
  createTerms(data) {
    return axios
      .post(API_URL + "hotel-setting/terms-and-condition", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // edit terms
  editTerms(data, id) {
    return axios
      .patch(API_URL + "hotel-setting/terms-and-condition/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete term
  deleteTerms(id) {
    return axios.delete(API_URL + "hotel-setting/terms-and-condition/" + id, {
      headers: authHeader(),
    });
  }

  // GUEST EXPERIENCE RELATED APIs

  //get guest experience list
  getGuestExperienceList() {
    return axios
      .get(API_URL + "hotel-setting/guest-experience", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit guest experience
  editGuestExperience(data, guest_experience_id) {
    return axios
      .patch(
        API_URL + "hotel-setting/guest-experience/" + guest_experience_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // CUSTOM QUESTIONS RELATED APIs

  //get custom question list
  getCustomQuestionList() {
    return axios
      .get(API_URL + "hotel-setting/custom-question", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // create custom question
  createCustomQuestion(data) {
    return axios
      .post(API_URL + "hotel-setting/custom-question", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update custom question
  updateCustomQuestion(data, question_id) {
    return axios
      .patch(API_URL + "hotel-setting/custom-question/" + question_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete custom question
  deleteCustomQuestion(question_id) {
    return axios
      .delete(API_URL + "hotel-setting/custom-question/" + question_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getEmailNotificationSetting(email_notification_type) {
    return axios
      .get(
        API_URL +
          "hotel-setting/notification/" +
          email_notification_type +
          "/email",
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  updateEmailNotificationSetting(email_notification_setting_id, data) {
    return axios
      .patch(
        API_URL +
          "hotel-setting/notification/email/" +
          email_notification_setting_id,
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  // TAXES RELATED APIs

  // tax-rule list
  getTaxList(filter = "") {
    return axios
      .get(API_URL + "hotel-setting/tax-rule" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // tax-rule details
  getTaxDetails(tax_id) {
    return axios
      .get(API_URL + "hotel-setting/tax-rule/" + tax_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // create tax-rule
  createTax(data) {
    return axios
      .post(API_URL + "hotel-setting/tax-rule", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // update tax-rule
  editTax(tax_id, data) {
    return axios
      .patch(API_URL + "hotel-setting/tax-rule/" + tax_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete tax-rule
  deleteTax(tax_id) {
    return axios
      .delete(API_URL + "hotel-setting/tax-rule/" + tax_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // CHARGES TYPE RELATED APIs

  // Charges-type list
  getChargesTypeList(filter = "") {
    return axios
      .get(API_URL + "hotel-setting/charges-type" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //charges-type details
  getChargesTypeDetails(charges_type_id) {
    return axios
      .get(API_URL + "hotel-setting/charges-type/" + charges_type_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Create charges-type
  createChargesType(data) {
    return axios
      .post(API_URL + "hotel-setting/charges-type", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update charges-type
  editChargesType(charges_type_id, data) {
    return axios
      .patch(API_URL + "hotel-setting/charges-type/" + charges_type_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete charges-type
  deleteChargesType(charges_type_id) {
    return axios
      .delete(API_URL + "hotel-setting/charges-type/" + charges_type_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // UPSELL RELATED APIs

  // Get all up sell
  getAllUpSell(filter) {
    return axios
      .get(API_URL + "hotel-setting/upsell" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Create new up sell
  createUpSell(data) {
    return axios
      .post(API_URL + "hotel-setting/upsell", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Update up sell by id
  updateUpSell(id, data) {
    return axios
      .patch(API_URL + "hotel-setting/upsell/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete up sell by id
  deleteUpSell(id) {
    return axios
      .delete(API_URL + "hotel-setting/upsell/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Get details of up sell item by id
  getUpSellDetails(id) {
    return axios
      .get(API_URL + "hotel-setting/upsell/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // EMAIL TEMPLATE RELATED APIs

  getNotification() {
    return axios
      .get(API_URL + "app-setting/notification-group", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  getEmailNotification(notification_group_id, recipient) {
    return axios
      .get(
        API_URL +
          `app-setting/${notification_group_id}/email-notification-type?is_recipient=${recipient}`,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  // NOTIFICATION AND ALERTS RELATED APIs

  // get unread notification list
  async getUnreadNotification() {
    const response = await axios.get(API_URL + "msg/notification-and-alerts", {
      headers: authHeader(),
    });
    return response.data;
  }
  // get  notification list
  async getNotificationList() {
    const response = await axios.get(
      API_URL + "msg/notification-and-alerts/list",
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  //  SMS RELATED  APIs

  // Get Tags
  getTagsOfGroup() {
    return axios
      .get(API_URL + "msg/group-tag", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // add tags
  addTagsOfGroup(data) {
    return axios
      .post(API_URL + "msg/group-tag", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Edit tags
  editTagsOfGroup(id, data) {
    return axios
      .patch(API_URL + "msg/group-tag/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get all inbox groups
  getInboxGroups(filter = "") {
    return axios
      .get(API_URL + "msg/inbox-group" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add new inbox group
  addInboxGroups(data) {
    return axios
      .post(API_URL + "msg/inbox-group", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Edit user group
  editInboxGroups(id, data) {
    return axios
      .patch(API_URL + "msg/inbox-group/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get a users to tags
  getAllSMSUsers() {
    return axios
      .get(API_URL + "msg/user", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get list of messages by group id
  getInboxChatGroup(group_id) {
    return axios
      .get(API_URL + "msg/inbox-group/" + group_id + "/message", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // To send message
  chatMessages(id, data) {
    return axios
      .post(API_URL + "msg/inbox-group/" + id + "/message", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // React to a messsage
  addReaction(message_id, data) {
    return axios
      .patch(API_URL + "msg/inbox-message/" + message_id + "/reaction", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // To follow a group
  followInboxGroup(id) {
    return axios
      .post(
        API_URL + "msg/inbox-group/" + id + "/followers/add",
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // To unfollow a group
  unfollowInboxGroup(id) {
    return axios
      .post(
        API_URL + "msg/inbox-group/" + id + "/followers/remove",
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // To Mark as Unread
  markAsUnread(msg_id) {
    return axios
      .patch(
        API_URL + "msg/inbox-message/" + msg_id + "/unread",
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Get list of personal messages by id
  getPersonalChatMessages(id) {
    return axios
      .get(API_URL + "msg/user-message/" + id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // To send message in personal
  personalChatMessages(id, data) {
    return axios
      .post(API_URL + "msg/user-message/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // React to a messsage
  addReactionPersonal(message_id, data) {
    return axios
      .patch(API_URL + "msg/user-message/" + message_id + "/reaction", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // get booking vise sms
  getSMSListByBooking(booking_id) {
    return axios
      .get(API_URL + "booking/" + booking_id + "/sms-message", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // get single user sms and info by guest id id
  getSingleGuestSMS(guest_id) {
    return axios
      .get(API_URL + "guest/" + guest_id + "/sms-message", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // send new SMS booking vise sms
  sendSMS(data) {
    return axios
      .post(API_URL + "send-sms-message", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // update SMS Read Status booking vise sms
  updateSMSReadStatus(message_id, data) {
    return axios
      .patch(API_URL + "sms-message/" + message_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // IOT LOCK CONFIG RELATED APIs

  // Get lock master data setting
  async getHotelIotMaster() {
    const response = await axios.get(API_URL + "iot/hotel/iot-master", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Get lock gateway list
  async getLockGatewayList() {
    const response = await axios.get(API_URL + "iot/hotel/iot-gateway", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Get lock device liar
  async getLockDeviceList(gateway_id, filter = "") {
    const response = await axios.get(
      API_URL + `iot/${gateway_id}/device` + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Get lock gateway list
  async getHotelRFIDEncoder() {
    const response = await axios.get(API_URL + "iot/hotel/rfid-encoder", {
      headers: authHeader(),
    });
    return response.data;
  }

  // IOT LOCK KEY LIST RELATED APIs

  // Get Device based Lock key list
  async getKeyList(filter = "") {
    const response = await axios.get(API_URL + "iot/hotel/key" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Get Deive based Lock key log list
  async getKeyLogList(filter = "") {
    const response = await axios.get(
      API_URL + "iot/hotel/device-event" + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Add New device key
  async addNewKey(data) {
    const response = await axios.post(API_URL + "iot/hotel/key", data, {
      headers: authHeader(),
    });
    return response.data;
  }

  // IOT LOCK RELATED APIs

  // Get room type list for lock
  async getRoomTypeLockList() {
    const response = await axios.get(API_URL + "iot/room-type", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Get floor list for lock
  async getFloorLockList() {
    const response = await axios.get(API_URL + "iot/floor", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Get room lock list
  async getRoomLockList(filter = "") {
    const response = await axios.get(API_URL + "iot/room" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Update room by lock
  async updateRoomLock(room_id, data) {
    const response = await axios.patch(API_URL + "iot/room/" + room_id, data, {
      headers: authHeader(),
    });
    return response.data;
  }

  // GET HOTEL MASTER DATA SETTING APIs
  async getLockMasterData() {
    const response = await axios.get(API_URL + "iot/iot-master", {
      headers: authHeader(),
    });
    return response.data;
  }

  //LOCK IOT GATEWAY RELATED APIs

  // Get gateway list
  async getGatewayList(filter = "") {
    const response = await axios.get(API_URL + "iot/gateway" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add gateway Data
  async addGateway(data) {
    const response = await axios.post(API_URL + "iot/gateway", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Edit Gateway Data
  async editGateWayData(gateway_id, data) {
    const response = await axios.patch(
      API_URL + "iot/gateway/" + gateway_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete gateway
  async deleteGateway(gateway_id) {
    const response = await axios.delete(API_URL + "iot/gateway/" + gateway_id, {
      headers: authHeader(),
    });
    return response.data;
  }

  //LOCK IOT DEVICE MODEL RELATED APIs

  // Get device model list
  async getDeviecModelList(filter = "") {
    const response = await axios.get(API_URL + "iot/device-model" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add device model Data
  async addDeviecModel(data) {
    const response = await axios.post(API_URL + "iot/device-model", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Edit deviec model Data
  async editDeviecModelData(device_model_id, data) {
    const response = await axios.patch(
      API_URL + "iot/device-model/" + device_model_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete device model
  async deleteDeviecModel(device_model_id) {
    const response = await axios.delete(
      API_URL + "iot/device-model/" + device_model_id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  //LOCK IOT DEVICE  RELATED APIs

  // Get device  list
  async getDevieceList(filter = "") {
    const response = await axios.get(API_URL + "iot/device" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add device  Data
  async addDeviece(data) {
    const response = await axios.post(API_URL + "iot/device", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Edit deviec  Data
  async editDevieceData(device__id, data) {
    const response = await axios.patch(
      API_URL + "iot/device/" + device__id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete device
  async deleteDevice(device__id) {
    const response = await axios.delete(API_URL + "iot/device/" + device__id, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Bulk update devices
  async bulkDeviceAdd(data) {
    const response = await axios.post(API_URL + "iot/upload/device-csv", data, {
      headers: authHeader(),
    });
    return response.data;
  }

  //LOCK IOT HOTEL MASTER DATA RELATED APIs

  // Get all hotel master data list
  async getHotelMasterList(filter = "") {
    const response = await axios.get(API_URL + "iot/iot-master" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add hotel based master data
  async addHotelBasedMasterData(data) {
    const response = await axios.post(API_URL + "iot/iot-master", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  //Edit hotel based master data
  async editHotelBasedMasterData(hotel_master_data_id, data) {
    const response = await axios.patch(
      API_URL + "iot/iot-master/" + hotel_master_data_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete hotel based master data
  async deleteHotelMasterData(hotel_master_data_id) {
    const response = await axios.delete(
      API_URL + "iot/iot-master/" + hotel_master_data_id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // RFID ENCODER RELATED APIs

  // Get RFID encoders liar
  async getRFIDEncoderList(filter = "") {
    const response = await axios.get(API_URL + "iot/rfid-encoder" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add RFID Encoder data
  async addRFIDEncoder(data) {
    const response = await axios.post(API_URL + "iot/rfid-encoder", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Edit RFID Encoder data
  async editRFIDEncoder(rfid_encoder_id, data) {
    const response = await axios.patch(
      API_URL + "iot/rfid-encoder/" + rfid_encoder_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete RFID Encoder data
  async deleteRFIDEncoder(rfid_encoder_id) {
    const response = await axios.delete(
      API_URL + "iot/rfid-encoder/" + rfid_encoder_id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // ROOM TYPE LIST RELATED APIs

  //room type list
  getRoomTypeList() {
    return axios
      .get(API_URL + "room/room-type", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create room type
  createRoomType(data) {
    return axios
      .post(API_URL + "room/room-type", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit room type
  editRoomType(data, room_type_id) {
    return axios
      .patch(API_URL + "room/room-type/" + room_type_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add room type image priority order
  addRoomTypeImage(room_type_id, data) {
    return axios
      .post(API_URL + "room/" + room_type_id + "/room-type-image", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update room type image priority order
  updateRoomTypeImage(room_type_id, image_id, data) {
    return axios
      .patch(
        API_URL + "room/" + room_type_id + "/room-type-image/" + image_id,
        data,
        {
          headers: authHeaderWithMultipartData(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Delete room type image priority order
  deleteRoomTypeImage(room_type_id, image_id) {
    return axios
      .delete(
        API_URL + "room/" + room_type_id + "/room-type-image/" + image_id,
        {
          headers: authHeaderWithMultipartData(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // BUILDING RELATED APIs

  //Building list
  getBuildingList() {
    return axios
      .get(API_URL + "room/building", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create building
  createBuilding(data) {
    return axios
      .post(API_URL + "room/building", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit building
  editBuilding(data, building_id) {
    return axios
      .patch(API_URL + "room/building/" + building_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete building
  deleteBuilding(building_id) {
    return axios
      .delete(API_URL + "room/building/" + building_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //add photos building
  addPhotoToBuilding(building_id, data) {
    return axios
      .post(API_URL + "room/" + building_id + "/building-image", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //update photos building
  updatePhotoToBuilding(building_id, image_id, data) {
    return axios
      .patch(
        API_URL + "room/" + building_id + "/building-image/" + image_id,
        data,
        {
          headers: authHeaderWithMultipartData(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  //delete photo building
  deletePhotoToBuilding(building_id, image_id) {
    return axios
      .delete(API_URL + "room/" + building_id + "/building-image/" + image_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // FLOOR RELATED RELATED APIs

  // Floor list based on building
  getFloorListByBuilding(query_str) {
    return axios
      .get(API_URL + "room/floor" + query_str, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //Floor list
  getFloorList() {
    return axios
      .get(API_URL + "room/floor", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create floor
  createFloor(data) {
    return axios
      .post(API_URL + "room/floor", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit floor
  editFloor(data, floor_id) {
    return axios
      .patch(API_URL + "room/floor/" + floor_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete floor
  deleteFloor(floor_id) {
    return axios
      .delete(API_URL + "room/floor/" + floor_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //add photos floor
  addPhotoToFloor(floor_id, data) {
    return axios
      .post(API_URL + "room/" + floor_id + "/floor-image", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //update photos floor
  updatePhotoToFloor(floor_id, image_id, data) {
    return axios
      .patch(API_URL + "room/" + floor_id + "/floor-image/" + image_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete photo floor
  deletePhotoToFloor(floor_id, image_id) {
    return axios
      .delete(API_URL + "room/" + floor_id + "/floor-image/" + image_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // BED  RELATED APIs

  //Bad list
  getBadList() {
    return axios
      .get(API_URL + "room/bad-type", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create bad-type
  createBad(data) {
    return axios
      .post(API_URL + "room/bad-type", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit bad-type
  updateBad(data, bad_type_id) {
    return axios
      .patch(API_URL + "room/bad-type/" + bad_type_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete bad-type
  deleteBad(bad_type_id) {
    return axios
      .delete(API_URL + "room/bad-type/" + bad_type_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // ROOM RELATED APIs

  // room get
  getRoomList() {
    return axios
      .get(API_URL + "room/list", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // room create
  createRoom(data) {
    return axios
      .post(API_URL + "room/list", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // room edit
  editRoom(data, room_id) {
    return axios
      .patch(API_URL + "room/room/" + room_id, data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // room edit
  updateRoomStatus(data) {
    return axios
      .post(API_URL + "room/house-keeping/status-change", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // calendar room get
  getRoomListForCalendar(filter = "") {
    return axios
      .get(API_URL + "room/room-calendar" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // ROOM AVAILABILITY RELATED APIs

  // room availability
  getRoomAvailability(query_str) {
    return axios
      .get(API_URL + "room/room-availability" + query_str, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update room availability
  updateRoomAvailability(data, room_availability_id) {
    return axios
      .patch(API_URL + "room/room-availability/" + room_availability_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // RATE PLAN RELATED APIs

  //rate plan list
  getRatePlanList() {
    return axios
      .get(API_URL + "room/rate-plan", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create rate plan
  createRatePlan(data) {
    return axios
      .post(API_URL + "room/rate-plan/", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //edit rate plan
  editRatePlan(data, rate_plan_id) {
    return axios
      .patch(API_URL + "room/rate-plan/" + rate_plan_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //rate plan details
  getRatePlanDetails(rate_plan_id) {
    return axios
      .get(API_URL + "room/rate-plan/" + rate_plan_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //rate plan price update
  updateRatePlanPrice(data, rate_plan_price_id) {
    return axios
      .patch(API_URL + "room/rate-plan-price/" + rate_plan_price_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // KIOSK LIST RELATED APIs

  // Get Kiosk  List
  getKioskStatus() {
    return axios
      .get(API_URL + "user/spa/kiosk", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // MENU RELATED APIs

  // Get Menu Header Images
  getMenuHeaderImages() {
    return axios
      .get(API_URL + "hotel/spa/directory-header-image", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add Menu Header Images
  addMenuHeaderImage(data) {
    return axios
      .post(API_URL + "hotel/spa/directory-header-image", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update Hotel Directory Menu page
  updateMenuHeaderImage(header_image_id, data) {
    return axios
      .patch(
        API_URL + "hotel.spa/directory-header-image/" + header_image_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Delete Hotel Directory Menu page
  deleteMenuHeaderImage(header_image_id) {
    return axios
      .delete(API_URL + "hotel/spa/directory-header-image/" + header_image_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // HOTELS RELATED APIS

  // Get Hotel List
  async getHotelsList() {
    const response = await axios.get(API_URL + "hotel/spa/hotel", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Sync Near By places based on hotel
  async getNearByPlaces(hotel_id) {
    const response = await axios.get(
      API_URL + `hotel/spa/hotel/${hotel_id}/nearby-place-sync`,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // APP FEATURE RELATED APIs
  async getAppFeature() {
    const response = await axios.get(API_URL + "app-setting/spa/app-feature", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add App Feature Data
  async addAppFeature(data) {
    const response = await axios.post(
      API_URL + "app-setting/spa/app-feature",
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  //Edit App Feature Theme Data
  async editAppFeature(app_id, data) {
    const response = await axios.patch(
      API_URL + "app-setting/spa/app-feature/" + app_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // BRAND RELATED APIs

  // Get Brand Data
  async getBrandData() {
    const response = await axios.get(API_URL + "hotel/spa/brand", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add Brand Data
  async addBrandData(data) {
    const response = await axios.post(API_URL + "hotel/spa/brand", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  //Edit Brand Data
  async editBrandData(id, data) {
    const response = await axios.patch(
      API_URL + "hotel/spa/brand/" + id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // BRAND THEME RELATED APIs

  // Get Brand Theme Data
  async getBrandThemeData(id) {
    const response = await axios.get(
      API_URL + "hotel/spa/brand/" + id + "/theme",
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Add Brand Theme Data
  async addBrandThemeData(id, data) {
    const response = await axios.post(
      API_URL + "hotel/spa/brand/" + id + "/theme",
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Edit Brand Theme Data
  async editBrandThemeData(id, newId, data) {
    const response = await axios.patch(
      API_URL + "hotel/spa/brand/" + id + "/theme/" + newId,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete Brand Theme Data
  async deleteBrandThemeData(brand_id, theme_id) {
    const response = await axios.delete(
      API_URL + "hotel/spa/brand/" + brand_id + "/theme/" + theme_id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  //VIDEO BOT RELATED APIs

  // get intents list
  async getIntentsList() {
    const response = await axios.get(VIDEO_BOT_API_BASE_URL + "intent/", {
      headers: videoBotAuthHeader(),
    });
    return response.data;
  }
  // add intent
  async addIntent(data) {
    const response = await axios.post(
      VIDEO_BOT_API_BASE_URL + "intent/",
      JSON.stringify(data),
      {
        headers: videoBotAuthHeader(),
      }
    );
    return response.data;
  }
  // update intent
  async updateIntent(data) {
    const response = await axios.put(
      VIDEO_BOT_API_BASE_URL + "intent/",
      JSON.stringify(data),
      {
        headers: videoBotAuthHeader(),
      }
    );
    return response.data;
  }
  // intent media file url generate
  async mediaFileUrlGenerate(data) {
    const response = await axios.post(
      VIDEO_BOT_API_BASE_URL + "uploadUrl/",
      JSON.stringify(data),
      {
        headers: videoBotAuthHeader(),
      }
    );
    return response.data;
  }
  // update intent
  async mediaFileUpload(URL, data) {
    const response = await axios.put(URL, data, {
      headers: videoBotAuthHeaderWithMultPartData(),
    });
    return response.data;
  }
  // get hotel list
  async getVideoChatHotelList() {
    const response = await axios.get(VIDEO_BOT_API_BASE_URL + "hotel/", {
      headers: videoBotAuthHeader(),
    });
    return response.data;
  }
  // get hotel details
  async getVideoChatHotelDetails(id) {
    const response = await axios.get(VIDEO_BOT_API_BASE_URL + "hotel/" + id, {
      headers: videoBotAuthHeader(),
    });
    return response.data;
  }
  // add new hotel
  async addVideoChatHotel(data) {
    const response = await axios.post(
      VIDEO_BOT_API_BASE_URL + "hotel/",
      JSON.stringify(data),
      {
        headers: videoBotAuthHeader(),
      }
    );
    return response.data;
  }
  async updateVideoChatHotel(data) {
    const response = await axios.put(
      VIDEO_BOT_API_BASE_URL + "hotel/",
      JSON.stringify(data),
      {
        headers: videoBotAuthHeader(),
      }
    );
    return response.data;
  }
  // delete hotel
  async deleteVideoChatHotel(id) {
    const response = await axios.delete(
      VIDEO_BOT_API_BASE_URL + "hotel/" + id,
      {
        headers: videoBotAuthHeader(),
      }
    );
    return response.data;
  }
  // add new intent in hotel
  async addUpdateVideoChatHotelIntent(data) {
    const response = await axios.post(
      VIDEO_BOT_API_BASE_URL + "hotelIntents",
      JSON.stringify(data),
      {
        headers: videoBotAuthHeader(),
      }
    );
    return response.data;
  }

  // BOT AVATAR RELATED APIs

  // get list of avatar
  async getBotAvatarList() {
    const response = await axios.get(VIDEO_BOT_API_BASE_URL + "avatar/", {
      headers: videoBotAuthHeader(),
    });
    return response.data;
  }
  // add avatar
  async addBotAvatar(data) {
    const response = await axios.post(
      VIDEO_BOT_API_BASE_URL + "avatar/",
      JSON.stringify(data),
      {
        headers: videoBotAuthHeader(),
      }
    );
    return response.data;
  }
  // get avatar data
  async getBotAvatarDetails(id) {
    const response = await axios.get(VIDEO_BOT_API_BASE_URL + "avatar/" + id, {
      headers: videoBotAuthHeader(),
    });
    return response.data;
  }
  // delete avatar data
  async deleteBotAvatar(id) {
    const response = await axios.delete(
      VIDEO_BOT_API_BASE_URL + "avatar/" + id,
      {
        headers: videoBotAuthHeader(),
      }
    );
    return response.data;
  }
  // Add/Update avatar in intent
  async addUpdateBotAvatarIntent(data) {
    const response = await axios.put(
      VIDEO_BOT_API_BASE_URL + "avatar/",
      JSON.stringify(data),
      {
        headers: videoBotAuthHeader(),
      }
    );
    return response.data;
  }
  // deploy update bot
  async deployBot() {
    const response = await axios.get(VIDEO_BOT_API_BASE_URL + "deploy", {
      headers: videoBotAuthHeader(),
    });
    return response.data;
  }

  // get list of slot
  async getSlotList() {
    const response = await axios.get(VIDEO_BOT_API_BASE_URL + "slots", {
      headers: videoBotAuthHeader(),
    });
    return response.data;
  }
  // Add/Update master slot
  async addUpdateSlot(data) {
    const response = await axios.put(
      VIDEO_BOT_API_BASE_URL + "slots/",
      JSON.stringify(data),
      {
        headers: videoBotAuthHeader(),
      }
    );
    return response.data;
  }
}
export default new UserService();
